import { render, staticRenderFns } from "./_user_course_card.vue?vue&type=template&id=ae849b96"
import script from "./_user_course_card.vue?vue&type=script&lang=js"
export * from "./_user_course_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports